//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";

export default {
	name: "LinkList",
	computed: {
		...mapGetters([
			"currentView",
			"locations",
			"stateNames",
		]),
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
		setCurrentView(e, value) {
			if (e.target.matches("select")) value = e.target.value;
			this.setStateValue(["currentView", value]);
			const statesContainer = document.querySelector(".states-container");
			this.$nextTick(() => {
				window.scroll({
					top: window.scrollY + statesContainer.getBoundingClientRect().top,
					left: 0,
					behavior: "smooth"
				});
			});
		}
	}
}
